<template>
  <div id="app">
    <h1>Наши товары</h1>
    <div class="card-container">
      <div
        class="card"
        v-for="(item, index) in paginatedProducts"
        :key="index"
      >
        <div class="image"></div>
        <h2>{{ item.name }}</h2>
        <p class="price">{{ item.price }} €</p>
      </div>
    </div>

    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">← Назад</button>
      <span>Страница {{ currentPage }} из {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">Вперёд →</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
export default {
  name: 'App',
  data() {
    return {
      products: [],
      currentPage: 1,
      pageSize: 8,
    };
  },
  computed: {
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.products.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.products.length / this.pageSize);
    },
  },
  created() {
    for (let i = 1; i <= 50; i++) {
      this.products.push({
        name: `Товар ${i}`,
        price: 50 + (i % 5) * 10,
      });
    }
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>
<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f7f7f7;
}

#app {
  padding: 20px;
  text-align: center;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  width: 200px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
}

.image {
  width: 100%;
  height: 120px;
  background: linear-gradient(to right, #4facfe, #00f2fe);
  border-radius: 6px;
  margin-bottom: 10px;
}

.price {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
}

.pagination {
  margin-top: 30px;
}

.pagination button {
  margin: 0 10px;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
}

.pagination span {
  font-size: 16px;
}
</style>
